// extracted by mini-css-extract-plugin
module.exports = {"txt":"Login_txt__2mSQm","space":"Login_space__2Bu9q","pad":"Login_pad__gzU81","error":"Login_error__2bBN-"};